import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AutoCompleteModule } from 'primeng/autocomplete';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { StylesApiService } from '../../api/styles/styles.api.service';
import { CommonFormsModule } from '../Forms/forms.module';
import { StylesService } from './services/styles.service';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { LayoutModule } from '../Layout/layout.module';
import { TemplateApiService } from '../../api/templates/template.api.service';

import { ManageStylesDialogComponent } from './components/ManageStylesDialog/manage-styles-dialog.component';
import { CommonBasicModule } from '../Basic/basic.module';
import { UsersModule } from '../../Core/Users/users.module';
import { TakeOverModule } from '../TakeOver/take-over.module';

export const stylesModuleImports = [
    LocalizationModule,
    CommonModule,
    CommonBasicModule,
    FormsModule,
    CoreDialogsModule,
    CommonFormsModule,
    AutoCompleteModule,
    MessageModule,
    TooltipModule,
    MiscModule,
    LayoutModule,
    UsersModule,
    TakeOverModule
];

export const stylesModuleDeclarations = [
    ManageStylesDialogComponent
];

@NgModule({
    imports: stylesModuleImports,
    declarations: stylesModuleDeclarations,
    exports: [
        ManageStylesDialogComponent
    ],
    providers: [
        StylesApiService,
        TemplateApiService,
        StylesService
    ]
})
export class StylesModule { }
